(() => {
  if (window.location.pathname !== '/blogs/news/koreanische-kosmetik') return;

  const content = document.querySelector('.mumuso-article-page .blog-post-content rte-formatter');
  if (!content) return;

  const productHeadings = [...content.querySelectorAll(':scope > h3')].filter((heading) => {
    const link = heading.querySelector('a[href*="mumuso.de/"]');
    return link && heading.previousElementSibling?.querySelector('img');
  });

  if (!productHeadings.length) return;

  const normalizeTitle = (title) =>
    title
      .replace(/[’']/g, '')
      .replace(/[^\p{L}\p{N}]+/gu, ' ')
      .trim()
      .split(/\s+/)
      .slice(0, 8)
      .join(' ');

  const escapeHtml = (value) =>
    String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;');

  const decodeHtml = (value) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  };

  const formatPrice = (price) => {
    const numericPrice = Number(price);
    const amount = Number.isInteger(numericPrice) && numericPrice >= 100 ? numericPrice / 100 : numericPrice;
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
  };

  const fetchProduct = async (title) => {
    const queries = [title, normalizeTitle(title)];
    for (const value of queries) {
      const query = encodeURIComponent(value);
      const response = await fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=4`);
      if (!response.ok) continue;
      const payload = await response.json();
      const product = payload.resources?.results?.products?.[0];
      if (product) {
        const handle = product.url.split('/products/')[1]?.split('?')[0];
        if (!handle) return product;
        const detailResponse = await fetch(`/products/${handle}.js`);
        if (!detailResponse.ok) return product;
        return { ...product, ...(await detailResponse.json()), url: `/products/${handle}` };
      }
    }
    return null;
  };

  const cartIcon = `
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none">
      <path d="M3 4h2l1.8 10.2a2 2 0 0 0 2 1.7h7.9a2 2 0 0 0 1.9-1.4L21 7H6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="9" cy="20" r="1" fill="currentColor"/><circle cx="18" cy="20" r="1" fill="currentColor"/>
    </svg>`;

  const wrapRoutine = () => {
    const heading = [...content.querySelectorAll(':scope > h2')].find((element) =>
      element.textContent.trim().startsWith('Die K-Beauty Routine mit Mumuso-Produkten')
    );
    if (!heading || heading.parentElement?.classList.contains('mumuso-kbeauty-routine')) return;

    const routine = document.createElement('section');
    routine.className = 'mumuso-kbeauty-routine';
    heading.before(routine);
    let node = heading;
    while (node && (node === heading || node.tagName !== 'H2')) {
      const next = node.nextElementSibling;
      routine.append(node);
      node = next;
    }
  };

  wrapRoutine();

  const groups = [];
  let currentGroup = [];

  productHeadings.forEach((heading, index) => {
    const previousProductHeading = productHeadings[index - 1];
    const hasSectionHeadingBetween = previousProductHeading
      ? [...content.children]
          .slice(
            [...content.children].indexOf(previousProductHeading) + 1,
            [...content.children].indexOf(heading)
          )
          .some((element) => element.tagName === 'H2')
      : false;

    if (hasSectionHeadingBetween && currentGroup.length) {
      groups.push(currentGroup);
      currentGroup = [];
    }
    currentGroup.push(heading);
  });
  if (currentGroup.length) groups.push(currentGroup);

  groups.forEach(async (headings) => {
    const entries = headings.map((heading) => {
      const imageParagraph = heading.previousElementSibling;
      const trailing = [];
      let node = heading.nextElementSibling;
      while (node && node.tagName !== 'H2' && node.tagName !== 'H3') {
        trailing.push(node);
        node = node.nextElementSibling;
      }
      return { heading, imageParagraph, trailing, title: heading.textContent.trim() };
    });

    const products = await Promise.all(entries.map((entry) => fetchProduct(entry.title)));
    const validProducts = products.filter(Boolean);
    if (!validProducts.length) return;

    const rail = document.createElement('section');
    rail.className = 'mumuso-news-product-rail';
    rail.setAttribute('aria-label', 'Empfohlene Produkte');
    rail.innerHTML = `
      <button class="mumuso-news-product-rail__arrow mumuso-news-product-rail__arrow--prev" type="button" aria-label="Vorherige Produkte">&#8249;</button>
      <div class="mumuso-news-product-rail__track">
        ${validProducts
          .map(
            (product) => {
              const images = (product.images || []).slice(0, 3);
              const variantId = product.variants?.find((variant) => variant.available)?.id;
              return `
              <article class="mumuso-news-product-card">
                <a class="mumuso-news-product-card__link" href="${escapeHtml(product.url.split('?')[0])}">
                  <span class="mumuso-news-product-card__media">
                    <img src="${escapeHtml(product.featured_image?.url || product.featured_image || product.image)}" alt="${escapeHtml(
                      product.featured_image?.alt || product.title
                    )}" loading="lazy" width="480" height="480">
                  </span>
                  <span class="mumuso-news-product-card__title">${escapeHtml(decodeHtml(product.title))}</span>
                </a>
                ${images.length > 1 ? `<div class="mumuso-news-product-card__variants" aria-label="Produktbilder">
                  ${images.map((image, index) => `<button type="button" class="mumuso-news-product-card__variant${index === 0 ? ' is-active' : ''}" data-image="${escapeHtml(image)}" aria-label="Produktbild ${index + 1}"><img src="${escapeHtml(image)}" alt="" loading="lazy" width="44" height="44"></button>`).join('')}
                </div>` : '<div class="mumuso-news-product-card__variants" aria-hidden="true"></div>'}
                <div class="mumuso-news-product-card__footer">
                  <strong>${formatPrice(product.price)}</strong>
                  ${variantId ? `<button class="mumuso-news-product-card__cart" type="button" data-variant-id="${variantId}" aria-label="In den Warenkorb">${cartIcon}</button>` : `<a class="mumuso-news-product-card__cart" href="${escapeHtml(product.url.split('?')[0])}" aria-label="Produkt ansehen">${cartIcon}</a>`}
                </div>
              </article>`;
            }
          )
          .join('')}
      </div>
      <button class="mumuso-news-product-rail__arrow mumuso-news-product-rail__arrow--next" type="button" aria-label="Nächste Produkte">&#8250;</button>`;

    entries[0].imageParagraph.before(rail);
    entries.forEach(({ heading, imageParagraph, trailing }) => {
      imageParagraph.remove();
      heading.remove();
      trailing.forEach((element) => element.remove());
    });

    const track = rail.querySelector('.mumuso-news-product-rail__track');
    rail.addEventListener('click', async (event) => {
      const variant = event.target.closest('.mumuso-news-product-card__variant');
      if (variant) {
        const card = variant.closest('.mumuso-news-product-card');
        card.querySelector('.mumuso-news-product-card__media img').src = variant.dataset.image;
        card.querySelectorAll('.mumuso-news-product-card__variant').forEach((button) => button.classList.toggle('is-active', button === variant));
        return;
      }

      const cart = event.target.closest('button.mumuso-news-product-card__cart');
      if (!cart || cart.disabled) return;
      cart.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(cart.dataset.variantId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Cart request failed');
        cart.classList.add('is-added');
        cart.setAttribute('aria-label', 'Zum Warenkorb hinzugefuegt');
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      } finally {
        cart.disabled = false;
      }
    });
    rail.querySelector('.mumuso-news-product-rail__arrow--prev').addEventListener('click', () => {
      track.scrollBy({ left: -track.clientWidth * 0.82, behavior: 'smooth' });
    });
    rail.querySelector('.mumuso-news-product-rail__arrow--next').addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth * 0.82, behavior: 'smooth' });
    });
  });
})();
